import * as React from 'react';
import { useState } from 'react';

import { CreateProject } from 'src/reusable/bom';
import useReduxState from "../../../hooks/useReduxState";
import { useBOMProjectStore } from "../../../hooks/bom_project";

const FindBom = (props) => {
    const [{ }, { fetch_bom_project_detail_with_bom }] = useBOMProjectStore();
    const [find_bom_input_bom_listing, set_find_bom_input_bom_listing] = useReduxState('', 'find_bom_input_bom_listing');
    const [search, setSearch] = useState('')
    const [liveTotalCountIncludingProjects] = useReduxState({}, 'BOM__liveTotalCountIncludingProjects',true);
    const [liveProjectTotalCountIncludingProjects, setLiveProjectTotalCountIncludingProjects] = useReduxState(0, 'BOM__liveProjectTotalCountIncludingProjects');
    const [{ total_bom }, { }, { }] = useBOMProjectStore();

    const getTotalCount = () => {
        let c = 0;
        if (find_bom_input_bom_listing) {
            Object.entries(liveTotalCountIncludingProjects).map((v) => {
                if (v[1] > 0) {
                    c = c + v[1];
                }
            });
            return c + liveProjectTotalCountIncludingProjects;
        }
        return total_bom + liveProjectTotalCountIncludingProjects;
    };
    return (
        <>
            <div className="row bs5 m-t-30">
                <div className="col-sm-6">
                    <form onSubmit={(event) =>{
                        event.preventDefault() ;
                        set_find_bom_input_bom_listing(search);
                    }} >
                        <div className="d-block d-flex">
                            <input className="ps-2 form-control form-control-sm w200 mb-0" placeholder="Find BOM" type="text"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value)
                                }}
                            />
                            <button className="btn btn-secondary ms-3  bs5 w80"
                                onClick={() => set_find_bom_input_bom_listing(search)}>find
                            </button>
                        </div>
                    </form>
                </div>
                <div className="col-sm-6 text-sm-end mt-3 mt-sm-0">
                    <CreateProject
                        afterBOMCreation={async () => {
                            await fetch_bom_project_detail_with_bom();
                        }}
                    />
                </div>
            </div>
            {find_bom_input_bom_listing.length > 0 &&
                <div className="row bs5 mt-4">

                    <span>
                        {getTotalCount() < 1 &&
                            <>
                                Message: Sorry! No Results Found. We can’t find any matches for search term "{find_bom_input_bom_listing}”, please try again.
                            </>
                        }
                        {getTotalCount() > 0 &&
                            <>
                                Results for "{find_bom_input_bom_listing}"
                            </>
                        }

                        <a
                            className="text-blue2 ms-2" data-toggle="modal" href={void (0)}
                            onClick={() => {
                                set_find_bom_input_bom_listing('');
                                setSearch('')
                            }}
                        >Clear</a>
                    </span>
                </div>
            }
        </>
    );
}

export default FindBom;